import React from 'react';
import { SurpriseIconSvg } from './SurpriseIconSvg';
import { PwaIconSvg } from './PwaIconSvg';
import { NotificationIconSvg } from './NotificationIconSvg';

export type PwaIconProps = {
    pwaInstalled: boolean | null,
    notificationEnabled: boolean | null,
};

// eslint-disable-next-line react/display-name
export const PwaIcon = React.memo((props: PwaIconProps)=> {
   const {
       pwaInstalled,
       notificationEnabled,
   } = props;

   return <React.Fragment>
       { (!pwaInstalled && !notificationEnabled) &&  <SurpriseIconSvg />}
       { (pwaInstalled && !notificationEnabled) &&  <NotificationIconSvg />}
       { (!pwaInstalled && notificationEnabled) &&  <PwaIconSvg />}
   </React.Fragment>;


});
